import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SmallInfo } from '@/assets/icons'
import { Modal } from '@/components/Modal'
import { BaseText, BaseView } from '@/components/base'
import { AppButton } from '@/components/AppButton'

export const TransactionFeeDescription: React.FC = () => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <button
        onClick={handleOpenModal}
        className="p-1 hover:opacity-70 transition-opacity"
        type="button"
      >
        <SmallInfo size={16} color="var(--label-disabled)" />
      </button>

      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <BaseView p={24} gap={20}>
          <BaseText
            fontSize={20}
            fontFamily="semibold"
            color="label.default"
            textAlign="center"
          >
            {t('transactions:transactionFee', 'Transaction Fee')}
          </BaseText>

          <BaseText
            fontSize={16}
            color="label.description"
            textAlign="center"
            style={{ lineHeight: '24px' }}
          >
            {
              'Transaction fees are charged by payment providers to process your transaction. This fee helps cover the cost of processing your payment.'
            }
          </BaseText>

          <AppButton label={'Got it'} onPress={handleCloseModal} />
        </BaseView>
      </Modal>
    </>
  )
}

export default TransactionFeeDescription
